// extracted by mini-css-extract-plugin
export default {"paragraph":"CardActionList_paragraph__vTFlp","cardList":"CardActionList_cardList__Wt7Io","card":"CardActionList_card__SF1PY"};